<template>
  <div class="home-page-container">
    <BookDirect v-if="$siteConfig.brand ==='BookDirect' || $siteConfig.brand === 'Solaire'" />
    <Tripening v-else />
  </div>
</template>
<script setup lang="ts">
import BookDirect from "~/components/HomePage/BookDirect.vue";
import Tripening from "~/components/HomePage/Tripening.vue";
import { useBrandSeoMeta, useHreflangTags } from '~/composables/useSeo'

const runtimeConfig = useRuntimeConfig()
const { $siteConfig } = useNuxtApp()
const brand = $siteConfig.value.brand
const isBookDirect = brand === 'BookDirect'

const tripeningMeta = `${brand} is a new way to plan your trip. Using advanced Artificial Intelligence and sourcing tours from all over the world, you will get the best travel experience. ${!isBookDirect ? 'Happy Tripening!': ''}`
const bookdirectMeta = 'Skip third-party platforms and book your next hotel stay directly with BookDirect.com. Trusted by travelers for real prices and real reviews.'

useBrandSeoMeta({
  title: isBookDirect
    ? `Book Direct & Save | ${runtimeConfig.public.brand}.com`
    : `${runtimeConfig.public.brand} | All Your Travel Needs. Anytime. Anywhere.`,
  description: isBookDirect ? bookdirectMeta : tripeningMeta,
  ogImage: `${runtimeConfig.public.baseURL}/images/og-default-${brand.toLowerCase()}.jpg`,
})

useHreflangTags('/')

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': brand,
  'url': runtimeConfig.public.baseURL,
  'potentialAction': {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': `${runtimeConfig.public.baseURL}/hotels/{search_term_string}`
    },
    'query-input': 'required name=search_term_string'
  }
}))

definePageMeta({
  layout: 'home-page'
})
</script>

<style lang="scss">
.home-page-container {
  width: 100%;
}
</style>
